module.exports = __webpack_public_path__ + "static/media/022.de05bd13.jpg";